import React from "react";

export function Section({ title, subtitle, action, children, testid }) {
  return (
    <section className="mt-7" data-testid={testid}>
      <div className="flex items-end justify-between mb-3 px-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold tracking-tight">{title}</h2>
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
